import React from 'react';

import SupplierEdit from '@components/shared/suppliers/SupplierEdit';
import supplierService from '@services/admin/supplierService';

export default function AdminSupplierEdit() {
  return <SupplierEdit service={supplierService} role="admin" />;
}
